<template>
  <div class="app">
    <el-card shadow="never" style="height:84px;display: flex !important;justify-content:  space-between;align-items: center;">
      <div style="width:100%;display: flex !important;justify-content: space-between;align-items: center;">
        <!-- Tab 导航部分 -->
        <el-tabs v-model="activeTab" class="d-l" @tab-click="handleTabClick">
          <el-tab-pane label="日数据" name="day" />
          <el-tab-pane label="月数据" name="month" />
          <el-tab-pane label="年数据" name="year" />
        </el-tabs>
        <!-- <div class="style-tab">
          <div
            class="style-tubiao"
            :class="{ 'active-bg': currentDisplayType === 'chart' }"
            @click="switchToChart"
          >
            新
            <img src="../../assets/images/13.小说/liebiao.png" alt="">
          </div>
          <span>|</span>
          <div
            class="style-liebiao"
            :class="{ 'active-bg': currentDisplayType === 'list' }"
            @click="switchToList"
          >
            <img src="../../assets/images/13.小说/tubiao.png" alt="">
            <div>旧</div>
          </div>
        </div> -->

      </div>

    </el-card>
    <!-- 数据展示区域，与导航分离 -->
    <div class="data-table">
      <keep-alive>
        <component
          :is="currentComponent"
          ref="activeComp"
          :display-type="currentDisplayType"
        />
      </keep-alive>
    </div>
    <!--
    <Display
      v-if="isDisplay"
      :start="start"
      :end="end"
      :complete="complete"
      @completeFunc="(isDisplay = false),(complete = false)"
    />
    -->
  </div>
</template>

<script>
import ReportDay from './reportDay'
import ReportMonth from './reportMonth'
import ReportYear from './reportYear'
// import Display from './components/display/index.vue'

export default {
  name: 'NovalReportTab',
  components: {
    ReportDay,
    ReportMonth,
    ReportYear
    // Display
  },
  data() {
    return {
      activeTab: 'day', // 默认激活“日数据”
      isDisplay: false,
      start: {
        x: null,
        y: null
      },
      end: {
        x: null,
        y: null
      },
      complete: false,
      showFlag: 1,
      currentDisplayType: 'chart' // 用于控制列表/图表显示模式
    }
  },
  computed: {
    // 根据当前 activeTab 返回对应的组件名称
    // eslint-disable-next-line vue/return-in-computed-property
    currentComponent() {
      if (this.activeTab === 'day') return 'ReportDay'
      if (this.activeTab === 'month') return 'ReportMonth'
      if (this.activeTab === 'year') return 'ReportYear'
    }
  },
  mounted() {
    // 默认加载日数据
    this.$nextTick(() => {
      // if (this.$refs.activeComp && this.activeTab === 'day') {
      //   // this.$refs.activeComp.getList && this.$refs.activeComp.getList() //之前是直接调用接口显示列表 现在是默认展示图表 现在是调用图表接口
      //   // this.$refs.activeComp.fetchMockData && this.$refs.activeComp.fetchMockData()
      //   // this.$refs.activeComp.getSelectListData &&
      //   //   this.$refs.activeComp.getSelectListData()
      // }
      if (this.$refs.activeComp) {
        this.$refs.activeComp.allday && this.$refs.activeComp.allday()
      }
    })
  },
  methods: {
    handleTabClick(tab) {
      // 切换 tab 时重置状态
      this.isDisplay = false
      this.start = { x: null, y: null }
      this.end = { x: null, y: null }
      this.complete = false

      // 切换完成后调用当前组件的方法加载数据
      this.$nextTick(() => {
        if (this.$refs.activeComp) {
          // this.$refs.activeComp.getList && this.$refs.activeComp.getList()
          // this.$refs.activeComp.getSelectListData &&
          //   this.$refs.activeComp.getSelectListData()
          this.$refs.activeComp.allday && this.$refs.activeComp.allday()
        }
      })
    },
    switchToChart() {
      this.currentDisplayType = 'chart'
    },
    switchToList() {
      this.currentDisplayType = 'list'
    }
  }
}
</script>

<style scoped lang="less">
.app {
  margin: 16px 20px;
}
 /deep/ .el-card__body {
  padding: 5px 20px !important;
}
.data-table {
  margin-top: 16px;
}
.style-tab {
  width: 124px;
  height: 36px;
  background-color: #f2f3f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    width: 42px;
    height: 24px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s;
    img {
      width: 24px;
      height: 24px;
    }
  }
  span {
    margin:0 5px;
    color: #ccc;
  }
}
/* 当处于激活状态时，设置背景为白色 */
.active-bg {
  background-color: #ffffff;
}

</style>
